/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Batch_Subtitle_Export_Activate_AccountInputs */



/**
* | output |
* | --- |
* | "Activate Account" |
*
* @param {Batch_Subtitle_Export_Activate_AccountInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const batch_subtitle_export_activate_account = /** @type {((inputs?: Batch_Subtitle_Export_Activate_AccountInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Batch_Subtitle_Export_Activate_AccountInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Activer le compte")
	if (locale === "de") return /** @type {LocalizedString} */ ("Konto aktivieren")
	if (locale === "it") return /** @type {LocalizedString} */ ("Attiva account")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Активировать аккаунт")
	if (locale === "es") return /** @type {LocalizedString} */ ("Activar cuenta")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("激活账户")
	if (locale === "ja") return /** @type {LocalizedString} */ ("アカウントを有効化")
	if (locale === "hi") return /** @type {LocalizedString} */ ("खाता सक्रिय करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Ativar conta")
	return /** @type {LocalizedString} */ ("Activate Account")
});